import React from "react";
import { isPhotoPart } from "@/features/tessa/components/utils/chatPhotos";
import type { TessaMessageRendererProps } from "@/features/tessa/types";

/** A photo the user sent with their message */
export const ChatBotPhotoPart: React.FC<TessaMessageRendererProps> = ({
  part
}) => {
  const photo = part as unknown as { type: string };
  if (!isPhotoPart(photo)) return null;

  return (
    <img
      src={photo.url}
      alt={photo.filename || "Photo"}
      className="my-2 max-h-48 max-w-full rounded-lg object-cover"
    />
  );
};
